document.addEventListener('DOMContentLoaded', function(){
$(document).ready(function () {
  quickView();
  $(".close").on( "click", function() {
    $("#quick-view").hide();
    $('#quick-view').removeClass();
  });
});
function quickView() {
  var modal = document.getElementById('quick-view');
  window.onclick = function(event) {
    console.log(event.target);
    if (event.target == modal) {
      modal.style.display = "none";
      $('#quick-view').removeClass();
    }
  };
  $(".quick-view").click(function () {
    event.preventDefault();
    var product_handle = $(this).data('handle');
    $('#quick-view'). attr("data-handle", product_handle);
    var collection_handle = $('.coll').data('handle');
    jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
      var title = product.title;
      var type = product.type;
      var price = 0;
      var original_price = 0;
      // var desc = product.description;
      var images = product.images;
      var variants = product.variants;
      var options = product.options;
      var quickviewPlace = $('.qv-product-options');
      var url = '/collections/' + collection_handle + '/products/' + product_handle;


      $('.qv-product-title').text(title);
      $('.qv-product-type').text(type);
      // $('.qv-product-description').html(desc);
      $('.view-product').attr('href', url);


      var quickview = $('.quick-view__modal-content');
      if (quickview.find('.qv-product-description').length > 0) {
        var description = product.description.replace(/(<([^>]+)>)/ig, "");
        description = description.split(" ").splice(0, 10).join(" ") + "...";
        quickview.find('.qv-product-description').text(description);
      } else {
        quickview.find('.qv-product-description').remove();
      }

      var imageCount = $(images).length;
      $(images).each(function (i, image) {
        if (i == imageCount - 1) {
          var image_embed = '<div><img src="' + image + '"></div>';
          image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
          $('.qv-product-images').append(image_embed);
          $('.qv-product-images').slick({
            'dots': true,
            'arrows': false,
            'respondTo': 'min',
            'useTransform': false
          }).css('opacity', '1');
        } else {
          image_embed = '<div><img src="' + image + '"></div>';
          image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
          $('.qv-product-images').append(image_embed);
        }
      });
      //show options
      enercosQuickView.createQuickViewOptions(product,quickviewPlace);
      enercosQuickView.createQuickViewSwatch(product,quickviewPlace);
      enercosQuickView.reloadPrice(product_handle);
      //end show options

    });
	$(document).on("change", "#quick-view input[type=radio]", function () {
      var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
      var optionValue = jQuery(this).val();
      jQuery(this)
      .closest('#quick-view')
      .find('.single-option-selector')
      .eq(optionIndex)
      .val(optionValue)
      .trigger('change');
    });  
    $(document).on("change", "#quick-view select", function () {
      enercosQuickView.reloadPrice(product_handle);
    });
    $('#quick-view').hide().html(quickViewContent).css('opacity', '1').fadeIn(function () {
      $('.qv-product-images').addClass('loaded');
    });
    modal.style.display = "block";
    var product_handle = $('#quick-view').attr('data-handle');
    $(document).on("click", ".quick-product", function () {
      var qty = $('.qv-quantity').val();
      var selectedOptions = '';
      var var_id = '';
      $('#quick-view select').each(function (i) {
        if (selectedOptions == '') {
          selectedOptions = $(this).val();
        } else {
          selectedOptions = selectedOptions + ' / ' + $(this).val();
        }
      });
      jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
        $(product.variants).each(function (i, v) {
          if (v.title == selectedOptions) {
            var_id = v.id;
            processCart();
          }
        });
      });
      function processCart() {
        jQuery.post('/cart/add.js', {
          quantity: qty,
          id: var_id
        }, null, "json").done(function (data) {
          //window.location.assign('/cart');
          $('.qv-add-to-cart-response').addClass('success').html('<p class="ajaxified-cart-feedback success" style=""><i class="fa fa-check"></i> Added to cart! <a href="/cart">View cart</a> or <a href="/collections/all">continue shopping</a>.</p>');
          jQuery.getJSON('/cart.js', function (cart, textStatus) {
            $('#CartCount').html(cart.item_count);
            $('#CartCountMini').html(cart.item_count);
            $('#CartCost').html(theme.Currency.formatMoney(cart.total_price,theme.moneyFormat));
            if ($('.site-header__car').length) {
              if(cart.item_count >0){
                var i;
                var j;
                var text = '';
                console.log(cart);
                text = '<div class="widget_shopping_cart_content  content-dropdown">';
                text += '<div class="cart_list ">';
                for (i = 0; i < cart.items.length; i++) {
                  j = i +1;
                  text += '<div class="media widget-product">';
                  text += '<div class="media-left">';
                  text += '<a href="'+cart.items[i].url+'" class="image pull-left">';
                  text += '<img alt="'+cart.items[i].featured_image.alt+'" src="'+cart.items[i].featured_image.url+'">';	
                  text += '</a>';
                  text += '</div>';
                  text += '<div class="cart-main-content media-body">';
                  text += '<h3 class="name">';
                  text += '<a href="'+cart.items[i].url+'">'+cart.items[i].title+'</a>';
                  text += '</h3>';
                  if(cart.items[i].variant_title != null){
                    if(cart.items[i].variant_title.includes('Default')){
                      text += '<p class="cart__meta-text">';
                      text += cart.items[i].variant_title;
                      text += '</p>';
                    }
                  }
                  text += '<p class="cart-item">';
                  text += '<span class="quantity">'+cart.items[i]['quantity']+' × <span class="price-amount amount">'+theme.Currency.formatMoney(cart.items[i].final_line_price,theme.moneyFormat)+'</span></span>';
                  text += '</p>'
                  text += '<a href="/cart/change?line='+j+'&amp;quantity=0" class="remove" title="Remove this item">×</a>'
                  text += '</div>';
                  text += '</div>';
                }
                text += '</div>';
                text += '<p class="total"><strong>Subtotal:</strong><span class="price-amount amount total-update-amount">'+theme.Currency.formatMoney(cart.total_price,theme.moneyFormat)+'</span></p>';
                text += '<p class="buttons clearfix"><a href="/cart" class="btn view-cart btn-default btn-normal pull-right">View cart</a><a href="/checkout" class="btn check-out btn-primary btn-normal pull-left">Check out</a></p>';
                text += '</div>';
              }else{
                var text = '';
                text = '<div class="widget_shopping_cart_content  content-dropdown"><p class="cart--empty-message">Your cart is currently empty.</p></div>';
              }
              $( ".widget_shopping_cart_content" ).remove();
              $('.site-header__car').append(text);
            }
            
          });
        })
        .fail(function ($xhr) {
          var data = $xhr.responseJSON;
          $('.qv-add-to-cart-response').addClass('error').html('<span><b>ERROR: </b>' + data.description);
        });
      }
    });
  });
};

$(window).resize(function () {
  if ($('#quick-view').is(':visible')) {
    $('.qv-product-images').slick('setPosition');
  }
});
  var enercosQuickView = {
    createQuickViewOptions: function(product, quickviewPlace) {
      if (product.variants.length >= 1) {
        var options = product.options;
        $(options).each(function (index, option) {
          var opt = option.name;
          var nojs = '';
          if(option.name == 'Title'){
          	 nojs = 'no-js';
          }
          var selectClass = '.option.' + opt.toLowerCase();
          quickviewPlace.append('<div class="'+nojs+' selector-wrapper js product-form__item '+enercosQuickView.convertToSlug(option.name+'-option')+'"><label for="SingleOptionSelector-'+index+'">'+option.name+'</label><select class="single-option-selector single-option-selector-product-template product-form__input" id="SingleOptionSelector-'+index+'" data-index="option'+index+'">  </select></div>');
          $(option.values).each(function (j, value) {
            var optionVal = value;
            $('#SingleOptionSelector-'+index).append('<option value="' + optionVal + '">' + value + '</option>');
          });
        });
      }
    },
    createQuickViewSwatch: function(product, quickviewPlace) {
      if (product.variants.length >= 1) { 
        var options = product.options;
        $(options).each(function (index, option) {
          var opt = option.name;
          var selectClass = '.option.' + opt.toLowerCase();
          var assetUrl = theme.assetsUrl.substring(0, theme.assetsUrl.lastIndexOf('?'));
		  var baseAssetUrl = assetUrl.replace("base.png", "");

          if(option.name.toLowerCase().indexOf("color") != -1 || option.name.toLowerCase().indexOf("colour") != -1){
            var swatchHtml = '';
            swatchHtml  = swatchHtml + '<div class="swatch  '+enercosQuickView.convertToSlug(option.name+'-option-hide')+'" data-option-index="'+index+'">';
            swatchHtml  = swatchHtml + '<div class="header">'+option.name+'</div>';
            $(option.values).each(function (j, value) {
              var optionVal = value;
              swatchHtml  = swatchHtml + '<div data-value="'+optionVal+'" class="swatch-element color '+enercosQuickView.convertToSlug(optionVal)+' soldout">';
              swatchHtml  = swatchHtml + '<div class="tooltip">'+optionVal+'</div>';
              swatchHtml  = swatchHtml + '<input id="swatch-'+index+'-'+optionVal+'" type="radio" name="option-'+index+'" value="'+optionVal+'" checked="">';
              swatchHtml  = swatchHtml + '<label for="swatch-'+index+'-'+optionVal+'" style="background-color: '+optionVal+'; background-image: url('+baseAssetUrl+optionVal+'.png)">';
              swatchHtml  = swatchHtml + '<img class="crossed-out" alt="" src="'+baseAssetUrl+'soldout.png">';
              swatchHtml  = swatchHtml + '</label>';
              swatchHtml  = swatchHtml + '</div>';
            });
            swatchHtml  = swatchHtml + '</div>';
            quickviewPlace.append(swatchHtml);
          }else{
            var swatchHtml = '';
            swatchHtml  = swatchHtml + '<div class="swatch '+enercosQuickView.convertToSlug(option.name+'-option-hide')+'" data-option-index="'+index+'">';
            swatchHtml  = swatchHtml + '<div class="header">'+option.name+'</div>';
            $(option.values).each(function (j, value) {
              var checked ='';
              if(j == 0) checked  = 'checked=""';
              var optionVal = value;
              swatchHtml  = swatchHtml + '<div data-value="'+optionVal+'" class="swatch-element '+enercosQuickView.convertToSlug(optionVal)+' soldout">';
              
              swatchHtml  = swatchHtml + '<input id="swatch-'+index+'-'+optionVal+'" type="radio" name="option-'+index+'" value="'+optionVal+'" '+checked+'>';
              swatchHtml  = swatchHtml + '<label for="swatch-'+index+'-'+optionVal+'">'+value;
              swatchHtml  = swatchHtml + '<img class="crossed-out" alt="" src="'+baseAssetUrl+'soldout.png">';
              swatchHtml  = swatchHtml + '</label>';
              
              swatchHtml  = swatchHtml + '</div>';
            });
            swatchHtml  = swatchHtml + '</div>';
            quickviewPlace.append(swatchHtml);
          }
        });
      }
    },
    convertToSlug: function(string) {
    	return string.toLowerCase().replace(/[^a-z0-9 -]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-');
    },
    reloadPrice: function(product_handle) {
      var selectedOptions = '';
      $('#quick-view select').each(function (i) {
        if (selectedOptions == '') {
          selectedOptions = $(this).val();
        } else {
          selectedOptions = selectedOptions + ' / ' + $(this).val();
        }
      });
      jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
        var flag = true;
        $(product.variants).each(function (i, v) {
          if (selectedOptions == v.title) {
            var price = theme.Currency.formatMoney(v.price,theme.moneyFormat);
            
            var v_inv = v.inventory_management;
            if(v.featured_image != null)
            {
            	$('.slick-current img').attr('src',v.featured_image.src);
            }            
            flag = false;
            $('.qv-product-price').html(price);
            if(v.compare_at_price == null ){
            	$('.qv-price__regular').hide();
            }else{
              var original_price = theme.Currency.formatMoney(v.compare_at_price,theme.moneyFormat);
              $('.qv-product-original-price').html(original_price);
            }
            if (v_inv == null) {
              $(".qv-add-button.quick-product").removeAttr("disabled");
              $('#AddToCartText-product-template').html("Add to cart");
            } else {
              if (!v.available) {
                $('.qv-add-button.quick-product').attr('disabled','disabled');
                $('#AddToCartText-product-template').html("Sold out");
              } else {
                $(".qv-add-button.quick-product").removeAttr("disabled");
                $('#AddToCartText-product-template').html("Add to cart");
              }
            }
             Currency.convertAll(theme.shopCurrency, jQuery('[name=currencies]').val());
          } 
//               else if(flag && product.options.length >1) {
//                 $('.qv-add-button.quick-product').attr('disabled','disabled');
//                 $('#AddToCartText-product-template').html("Sold out");
//             }
              if(v.options.length > 1 && v.available){
                $(v.options).each(function (index, option) {
                  jQuery('.swatch[data-option-index="'+index+'"] .'+enercosQuickView.convertToSlug(option)).removeClass('soldout').addClass('available').find(':radio').removeAttr('disabled');
                });
              }                                                          
        });
      });	
    }
  };  
});  